/* eslint-disable no-console */
import {Modal} from 'antd';
import React from 'react';

import ReactVideoPlayer from './ReactVideoPlayer';

const ModalReactPlayer: React.FC<{video: any; onClose: () => void}> = ({
  video,
  onClose
}) => {
  return (
    <Modal
      open={video?.url}
      onCancel={onClose}
      centered
      footer={null}
      zIndex={5000}
      width={'50%'}
      style={{height: 'fit-content'}}
      title={video?.subTitle}
      destroyOnClose
    >
      <ReactVideoPlayer video={video} />
    </Modal>
  );
};

export default ModalReactPlayer;
